<div #footer class='modal-footer primary-bg-color' [style.top.px]="footerTopPosition">
  <div class="footer-overlay visible-xs m-0"></div>

  <div class='button-controls text-right'>

    <button class='btn primary-bg-color action-text-color primary-bg-border-color btn-back no-left-padding text-uppercase action-btn fw-600 font-secondary text-uppercase'
            *ngIf='showBackBtn'
            (click)='backBtnClicked()'>
      <span class="arrow-left"></span>{{'component.special_wizard_modal_footer.back' | translate}}
    </button>

    <div class="separator"
      *ngIf="(showBackBtn ||
        (!showBackBtn && showNextBtn) ||
        (showCancelBtn && !showNextBtn && !showDoneBtn)) ||
        (!showCancelBtn && showDoneBtn)
        && !shouldForceAddToOrder && !specialAdditionFailedMode
      ">
    </div>

    <button
      *ngIf="showCancelBtn"
      class="btn primary-bg-color action-text-color text-uppercase dismiss-btn action-btn font-secondary"
      (click)='cancelClicked()'>
      Cancel
    </button>

    <button
      class='btn action-bg-color action-inverse-text-color btn-next-choice action-border-color text-uppercase action-btn fw-600 margin-right-30 no-right-padding font-secondary'
      *ngIf='showNextBtn'
      (click)="goToNextChoice()">
      <span [ngClass]="{'button-text-wrapper': showBackBtn}">
        {{'component.special_wizard_modal_footer.next' | translate}}: {{orderableItem.choiceGroups?.length ? nextChoiceGroup?.name : nextChoice?.name}}
      </span>
    </button>

    <button ftsAuditableButton
            *ngIf="showDoneBtn && !isLastStep"
            auditName="Special Wizard's 'NEXT'"
            (click)="this.nextStepClick.emit()"
            class='btn action-bg-color action-inverse-text-color btn-next-choice action-border-color text-uppercase primary-btn margin-right-30 no-right-padding action-btn font-secondary'>
      {{'component.special_wizard_modal_footer.done' | translate}},
      {{('component.special_wizard_modal_footer.go_step' | translate: {step: stepOrdinal + 2})}}
    </button>

    <button ftsAuditableButton
            *ngIf="showDoneBtn && isLastStep"
            auditName="Special Wizard's 'ADD TO ORDER'"
            ftsAsyncButton
            [subscription]="addingSpecialToOrder"
            (click)="this.addToOrderClick.emit()"
            class='btn action-bg-color action-inverse-text-color action-border-color text-uppercase primary-btn action-btn font-secondary'>
            {{'component.special_wizard_modal_footer.done' | translate}}{{'component.special_wizard_modal_footer.comma_symbol' | translate}}
            {{'component.special_wizard_modal_footer.add' | translate}}
    </button>
  </div>
</div>
